import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  LoadingPopUp,
  ScreenDisplayHeaderActions,
  TabButtonFlatButton,
  TextInputField,
} from "../../../common-components";
import {
  AddProductDescriptionInformation,
  AddProductImageAdd,
  AddProductPrimaryInformation,
  AddVehiclePopUp,
  ManageVehiclePopUp,
  UserRegisterVehicleCard,
  VehicleCard,
  VehicleListCard,
} from "./components";
import SearchBar from "../../../common-components/search-bar/SearchBar";

const VehicleDisplay = ({
  width,
  height,
  setToastPop,
  setMessage,
  setLoading,
  loading,
  setPopUpTitle,
  auth,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedView, setSelectedView] = useState("list");
  const [search, setSearch] = useState("");
  const [activeView, setActiveView] = useState("catalog");
  const [filterTest, setFilterTest] = useState(false);
  const [filterTest1, setFilterTest1] = useState(false);
  const [addProductStep, setAddProductStep] = useState(1);
  const [regsitrationNr, setRegistrationNr] = useState("");
  const [vinNr, setVinNr] = useState("");
  const [licenceNr, setLicenceNr] = useState("");
  const [engineNr, setEngineNr] = useState("");
  const [make, setMake] = useState(null);
  const [makeArray, setMakeArray] = useState(null);
  const [originalMakeArray, setOriginalMakeArray] = useState([]);
  const [series, setSeries] = useState(null);
  const [seriesArray, setSeriesArray] = useState(null);
  const [enatisVehicleArray, setEnatisVehicleArray] = useState(null);
  const [originalEnatisVehicleArray, setOriginalEnatisVehicleArray] =
    useState(null);
  const [refresh, setRefresh] = useState(false);
  const [searchRegister, setSearchRegister] = useState(true);

  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const [tableDisplay, setTableDisplay] = useState("enatis");

  const [selectedMake, setSelectedMake] = useState(null);
  const [makeCardHover, setMakeCardHover] = useState(null);
  const [selectedSeries, setSelectedSeries] = useState(null);
  const [seriesCardHover, setSeriesCardHover] = useState(null);

  const [addMake, setAddMake] = useState(false);
  const [addSeries, setAddSeires] = useState(false);
  const [makeImage, setMakeImage] = useState("");
  const [makeName, setMakeName] = useState("");
  const [seriesImage, setSeriesImage] = useState("");
  const [seriesName, setSeriesName] = useState("");

  const [linkedUserIdNumber, setLinkedUserIdNumber] = useState("");

  const [selectedMakeEdit, setSelectedMakeEdit] = useState("");
  const [selectedMakeEditImage, setSelectedMakeEditImage] = useState("");

  const [selectedSeriesEdit, setSelectedSeriesEdit] = useState("");
  const [selectedSeriesEditImage, setSelectedSeriesEditImage] = useState("");

  const [userRegisteredVehicles, setUserRegisteredVehicles] = useState(null);
  const [originalUsersArray, setOriginalUsersArray] = useState(null);

  // seraches
  const [seriesSearch, setSeriesSearch] = useState("");
  const [makeSearch, setMakeSearch] = useState("");

  // dlete pop up controls

  const [seriesDeleteAreYouSure, setSeriesDeleteAreYouSure] = useState(false);
  const [manageDeleteAreYouSure, setManageDeleteAreYouSure] = useState(false);

  const DataClear = () => {
    setRegistrationNr("");
    setVinNr("");
    setLicenceNr("");
    setEngineNr("");
    setSearchRegister(true);
    setMake(null);
    setSeries("");
    setLinkedUserIdNumber("");
  };

  const GetAllEnatisVehicles = async () => {
    await fetch(
      process.env.REACT_APP_BACKEND_URL + "/enatis/getEnatisMasterList"
    )
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setEnatisVehicleArray(resData.enatisVehicles);

        setOriginalEnatisVehicleArray(resData.enatisVehicles);
      });
  };

  const GetAllMakeData = async () => {
    await fetch(process.env.REACT_APP_BACKEND_URL + "/enatis/getMakeMasterList")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setMakeArray(resData.data);
        setOriginalMakeArray(resData.data);
      });
  };

  const GetSeriesDataLinkedToMake = async (value) => {
    if (value) {
      setLoading(true);

      try {
        const response = await fetch(
          process.env.REACT_APP_BACKEND_URL + "/enatis/getSeriesMasterList",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              // Authorization: `bearer ${token}`,
            },
            body: JSON.stringify({
              make: value,
            }),
          }
        );

        const respnseData = await response.json();
        if (respnseData.data) {
          setSeriesArray(respnseData.data);
          setLoading(false);
          // setVehicleSearchArray(respnseData.enatisVehicles);
        }
      } catch (err) {
        setLoading(false);
        console.log("error", err);
      }
    }
  };

  const SubmitHandler = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        // process.env.REACT_APP_BACKEND_URL +
        //   "/enatis/createNewMasterEnatisVehicle",
        "https://driverfrienddatabase-h2aa.onrender.com/enatis/createNewMasterEnatisVehicle",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            registerNr: regsitrationNr,
            vinNr: vinNr,
            licenceNr: licenceNr,
            engineNr: engineNr,
            make: make,
            series: series,
            addedBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
            editedBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
            linkedIDnumber: linkedUserIdNumber,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.success) {
        setToastPop(true);
        setMessage("You have succesfully uploaded a new vehicle");
        setPopUpTitle("SUCCESS");
        setActiveView("catalog");
        setLoading(false);
        setRefresh(refresh ? false : true);
        DataClear();
      } else {
        setToastPop(true);
        setMessage(respnseData.error);
        setPopUpTitle("FAILURE");
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  const AddNewMake = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/enatis/createNewMake",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            name: makeName.toLocaleUpperCase(),
            imageLink: makeImage,
            createdBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setRefresh(refresh ? false : true);
        setLoading(false);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setToastPop(true);
        setAddMake(false);
        setMakeName("");
        setMakeImage("");
      } else {
        setPopUpTitle("FAILURE");
        setLoading(false);
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      setPopUpTitle("FAILURE");
      setRefresh(refresh ? false : true);
      setLoading(false);
      setMessage(
        "Error occured contact support but make sure you have betwork first"
      );
      setToastPop(true);
    }
  };

  const AddNewSeries = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        // process.env.REACT_APP_BACKEND_URL + "/enatis/createNewSeries",
        "https://driverfrienddatabase-h2aa.onrender.com/enatis/createNewSeries",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            name: seriesName.toLocaleUpperCase(),
            make: selectedMake.name,
            imageLink: seriesImage,
            createdBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setMessage(respnseData.success);
        setToastPop(true);
        setAddSeires(false);
        GetSeriesDataLinkedToMake(selectedMake.name);
        setSeriesName("");
        setSeriesImage("");
      } else {
        setPopUpTitle("FAILURE");
        setLoading(false);
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      setPopUpTitle("FAILURE");
      setRefresh(refresh ? false : true);
      setLoading(false);
      setMessage(
        "Error occured contact support but make sure you have betwork first"
      );
      setToastPop(true);
    }
  };

  const EditMake = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" + "/enatis/editMake",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: selectedMake._id,
            name: selectedMakeEdit.toLocaleUpperCase(),
            imageLink: selectedMakeEditImage,
            editedBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
            make: selectedMake.name,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setMessage(respnseData.success);
        setToastPop(true);
        setRefresh(refresh ? false : true);
        setSelectedMake(null);
      } else {
        setPopUpTitle("FAILURE");
        setLoading(false);
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      console.log("error", err);
      setPopUpTitle("FAILURE");
      setRefresh(refresh ? false : true);
      setLoading(false);
      setMessage(
        "Error occured contact support but make sure you have network first"
      );
      setToastPop(true);
    }
  };

  const EditSeries = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/enatis/editSeries",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: selectedSeries._id,
            name: selectedSeriesEdit.toLocaleUpperCase(),
            imageLink: selectedSeriesEditImage,
            editedBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setMessage(respnseData.success);
        setToastPop(true);
        GetSeriesDataLinkedToMake(selectedMake.name);
        setSelectedSeries(null);
      } else {
        setPopUpTitle("FAILURE");
        setLoading(false);
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      console.log("error", err);
      setPopUpTitle("FAILURE");
      setRefresh(refresh ? false : true);
      setLoading(false);
      setMessage(
        "Error occured contact support but make sure you have network first"
      );
      setToastPop(true);
    }
  };

  const deleteSeries = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/enatis/deleteSeriesData",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: selectedSeries._id,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setMessage(respnseData.success);
        setToastPop(true);
        GetSeriesDataLinkedToMake(selectedMake.name);
        setSeriesDeleteAreYouSure(false);
        setSelectedSeries(null);
        // setSelectedSeries(null);
      } else {
        setPopUpTitle("FAILURE");
        setLoading(false);
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      console.log("error", err);
      setPopUpTitle("FAILURE");
      setRefresh(refresh ? false : true);
      setLoading(false);
      setMessage(
        "Error occured contact support but make sure you have network first"
      );
      setToastPop(true);
    }
  };

  const deleteMake = async () => {
    console.log("make", selectedMake);
    setLoading(true);
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/enatis/deleteMakeData",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            id: selectedMake._id,
          }),
        }
      );

      const respnseData = await response.json();
      console.log("respnseData make", respnseData);
      if (respnseData.success) {
        setManageDeleteAreYouSure(false);
        setSelectedMake(null);
        setSeriesDeleteAreYouSure(false);
        setSelectedSeries(null);
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setMessage(respnseData.success);
        setToastPop(true);
        // GetSeriesDataLinkedToMake(selectedMake.name);

        setRefresh(refresh ? false : true);
        // setSelectedSeries(null);
      } else {
        setPopUpTitle("FAILURE");
        setLoading(false);
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      console.log("error", err);
      setPopUpTitle("FAILURE");
      setRefresh(refresh ? false : true);
      setLoading(false);
      setMessage(
        "Error occured contact support but make sure you have network first"
      );
      setToastPop(true);
    }
  };

  const GetUserRegisteredVehicles = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userVehicles/getAllUserVehicles",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth.customerUserData.userId,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setLoading(false);

        setUserRegisteredVehicles(respnseData.vehicleList);
        setOriginalUsersArray(respnseData.vehicleList);
      } else {
        setPopUpTitle("FAILURE");
        setLoading(false);
        setMessage(respnseData.error);
        setToastPop(true);
      }
    } catch (err) {
      setPopUpTitle("FAILURE");

      setLoading(false);
      setMessage(
        "Error occured contact support but make sure you have network first"
      );
      setToastPop(true);
    }
  };

  useEffect(() => {
    setOpen(true);
    GetAllEnatisVehicles();
    GetAllMakeData();
    GetUserRegisteredVehicles();
  }, [refresh]);
  useEffect(() => {
    if (selectedMake) {
      setSelectedMakeEdit(selectedMake.name);
      setSelectedMakeEditImage(selectedMake.imageLink);
    }
  }, [selectedMake]);
  useEffect(() => {
    if (selectedSeries) {
      setSelectedSeriesEdit(selectedSeries.name);
      setSelectedSeriesEditImage(selectedSeries.imageLink);
    }
  }, [selectedSeries]);

  return (
    <div
      style={{
        height: open ? "100%" : 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "top",
        transition: "all 0.8s",
        // backgroundColor: open ? colors.secondaryGrey : colors.primaryBlue,
        //borderStyle: "solid",
        // borderWidth: 3,
        // borderColor: colors.greenDark
      }}
    >
      {/* catalog view */}
      <div
        style={{
          display: "flex",
          height: 40,
          backgroundColor: colors.greenDark,
          top: -40,
          position: "absolute",
          overflow: "visible",
        }}
      >
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"ENATIS VEHICLES"}
            backgroundColor={
              tableDisplay === "enatis"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "enatis" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("enatis")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"MANAGE MAKES/SERIES"}
            backgroundColor={
              tableDisplay === "makeAndSeries"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "makeAndSeries" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("makeAndSeries")}
          />
        </div>

        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"DRIVER VEHICLES"}
            backgroundColor={
              tableDisplay === "driverVehicles"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "driverVehicles"
                ? colors.greenDark
                : colors.white
            }
            onClick={() => setTableDisplay("driverVehicles")}
          />
        </div>
      </div>
      {tableDisplay === "enatis" ? (
        <div
          style={{
            height: activeView === "catalog" ? "100%" : 0,
            width: "100%",
            //   borderStyle: "solid",
            //borderRadius: 15,
            //   borderColor: colors.primaryBlue,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            transition: "height 0.3s",
          }}
        >
          <ScreenDisplayHeaderActions
            title={"ENATIS VEHICLE REPOSITORY"}
            iconRight1={require("../../../../images/icons/blockWhite.png")}
            iconRight1Height={30}
            iconRight1Width={30}
            iconRight2={require("../../../../images/icons/listWhite.png")}
            iconRight1Change={require("../../../../images/icons/blockDarkBlue.png")}
            iconRight2Change={require("../../../../images/icons/listDarkBlue.png")}
            iconRight2Height={30}
            iconRight2Width={30}
            products={true}
            //   marginBottom={10}
            selected={selectedView}
            onListClick={() => setSelectedView("list")}
            onBlockClick={() => setSelectedView("block")}
            search={search}
            onSearchChange={(e) => setSearch(e.target.value)}
            onAddProductClick={() => setActiveView("add")}
            marginBottom={20}
            vehicles={true}
            originalDataArray={originalEnatisVehicleArray}
            searchArray={enatisVehicleArray}
            setSearchArray={setEnatisVehicleArray}
          />
          <div
            style={{
              flex: 1,
              width: "100%",
              display: "flex",
              flexDirection: selectedView === "list" ? "column" : "row",
            }}
          >
            {/* list view */}
            {selectedView === "list" ? (
              <div
                style={{
                  width: "100%",
                  backgroundColor: colors.greenDark,
                  height: 40,
                  display: "flex",
                }}
              >
                <div
                  style={{
                    flex: 0.15,
                    color: colors.white,
                    fontWeight: "bold",
                    fontSize: 12,
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <div style={{ marginLeft: 10 }}>REGISTER NR</div>
                  </div>
                </div>
                <div
                  style={{
                    flex: 0.15,
                    color: colors.white,
                    fontWeight: "bold",
                    fontSize: 12,
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <div style={{ marginLeft: 10 }}> LICENCE NR</div>
                  </div>
                </div>
                <div
                  style={{
                    flex: 0.2,
                    color: colors.white,
                    fontWeight: "bold",
                    fontSize: 12,
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "100%" }}> VIN NR</div>
                </div>
                <div
                  style={{
                    flex: 0.2,
                    color: colors.white,
                    fontWeight: "bold",
                    fontSize: 12,
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "100%" }}> ENGINE NR</div>
                </div>
                <div
                  style={{
                    flex: 0.1,
                    color: colors.white,
                    fontWeight: "bold",
                    fontSize: 12,
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "100%" }}> MAKE</div>
                </div>
                <div
                  style={{
                    flex: 0.1,
                    color: colors.white,
                    fontWeight: "bold",
                    fontSize: 12,
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "100%" }}>SERIES</div>
                </div>
                <div
                  style={{
                    flex: 0.1,
                    color: colors.white,
                    fontWeight: "bold",
                    fontSize: 12,
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "left",
                  }}
                >
                  ACTIONS
                </div>
              </div>
            ) : null}
            <div
              style={{
                maxHeight: height > 800 ? 730 : height > 740 ? 600 : 550,
                minHeight: 300,
                height: "90%",
                flex: 1,
                borderWidth: 1,
                flexDirection: selectedView === "list" ? "column" : null,
                flexWrap: selectedView === "list" ? null : "wrap",
                overflowY: selectedView === "list" ? "scroll" : "auto",
                overflowX: "hidden",
                display: "flex",
                justifyContent:
                  selectedView === "list" ? "flex-start" : "center",
                alignItems: "center",
              }}
            >
              {selectedView === "block"
                ? enatisVehicleArray
                  ? enatisVehicleArray.map((vehicle, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            height: 220,
                            width: width > 1200 ? 470 : 400,

                            borderRadius: 10,
                            margin: 20,
                            position: "relative",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                            // overflow: "hidden",
                          }}
                        >
                          <VehicleCard
                            productName={vehicle.id}
                            onManageClick={() => {
                              setActiveView("manage");
                              setSelectedVehicle(vehicle);
                            }}
                            registrationNr={vehicle.registerNr}
                            vin_nr={vehicle.vinNr}
                            licenceNr={vehicle.licenceNr}
                            engineNr={vehicle.engineNr}
                            make={vehicle.make}
                            series={vehicle.series}
                          />
                        </div>
                      );
                    })
                  : null
                : null}
              {selectedView === "list"
                ? enatisVehicleArray
                  ? enatisVehicleArray.map((vehicle, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            width: "100%",
                          }}
                        >
                          <VehicleListCard
                            vehicle={vehicle}
                            onManageClick={() => {
                              setActiveView("manage");
                              setSelectedVehicle(vehicle);
                            }}
                          />
                        </div>
                      );
                    })
                  : null
                : null}
              {selectedView === "list" ? (
                <div style={{ padding: 70 }}></div>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
      {tableDisplay === "makeAndSeries" ? (
        <div
          style={{
            height: activeView === "catalog" ? "100%" : 0,
            width: "100%",
            borderRadius: 15,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            transition: "height 0.3s",
          }}
        >
          {/* page menu options */}
          <div style={{ height: 60, display: "flex", alignItems: "center" }}>
            <div
              style={{
                fontSize: 18,
                color: colors.secondaryDarkBlue,
                fontWeight: "bold",
                marginLeft: 20,
              }}
            >
              MANAGE MAKE & SERIES
            </div>
            <div style={{ flex: 0.5 }}></div>
            {/* <SearchBar
              originalSearchArray={originalMakeArray}
              arrayToSearchInput={makeArray}
              setResultsArray={setMakeArray}
            /> */}
            <TextInputField
              mini={true}
              placeholder={"TYPE HERE TO SEARCH MAKE"}
              marginTop={-5}
              height={20}
              onChange={(e) => setMakeSearch(e.target.value)}
              value={makeSearch}
            />
            <div style={{ flex: 0.5 }}></div>
            {selectedMake ? null : (
              <BaseButtons
                label={"ADD MAKE"}
                backgroundColor={colors.greenLight}
                onClick={() => setAddMake(true)}
                width={150}
              />
            )}
            <div style={{ minWidth: 10 }} />
          </div>
          {/* manage make list */}
          <div
            style={{
              width: "100%",
              flex: 1,
              flexWrap: "wrap",
              display: "flex",
              overflow: "scroll",
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            {makeArray
              ? makeArray.map((item, index) => {
                  return item.name.match(makeSearch.toLocaleUpperCase()) ? (
                    <div
                      key={index}
                      onMouseOver={() => setMakeCardHover(index)}
                      onMouseOut={() => setMakeCardHover(null)}
                      onClick={() => {
                        setSelectedMake(item);
                        GetSeriesDataLinkedToMake(item.name);
                      }}
                      style={{
                        height: 150,
                        width: 150,
                        margin: 10,
                        backgroundColor:
                          makeCardHover === index ? colors.white : null,
                        borderRadius: 10,
                        WebkitBoxShadow:
                          makeCardHover === index
                            ? "-5px 5px 15px -1px #00000070"
                            : "0px 0px 0px 0px #00000070",
                        display: "flex",
                        overflow: "hidden",
                        flexDirection: "column",
                        borderStyle: "solid",
                        borderWidth: makeCardHover === index ? 3 : 0,
                        transition: "all 0.1s",
                        borderColor: colors.greenDark,
                        position: "relative",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        alt="logo"
                        style={{ height: 100, width: 120, marginBottom: 20 }}
                        src={item.imageLink}
                      />
                      <div
                        style={{
                          position: "absolute",
                          bottom: 0,
                          width: "100%",
                        }}
                      >
                        <div style={{ backgroundColor: "#00000040" }}>
                          <div
                            style={{
                              marginLeft: 10,
                              paddingTop: 5,
                              paddingBottom: 5,
                            }}
                          >
                            {item.name}
                          </div>
                        </div>
                        {/* <TextInputField
                          value={item.name}
                          readOnly={true}
                          mini={true}
                        /> */}
                      </div>
                    </div>
                  ) : null;
                })
              : null}
          </div>
          {/* add new make screen */}
          <div
            style={{
              height: addMake ? "100%" : 0,
              width: "100%",
              overflow: "hidden",
              backgroundColor: colors.secondaryGrey,
              //position: "absolute",
              //top: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              transition: "all 0.3s",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                marginBottom: 20,
                fontSize: 20,
                marginTop: 20,
                width: "100%",
              }}
            >
              <div style={{ marginLeft: 20 }}>ADD NEW MAKE</div>
            </div>
            <div
              style={{
                display: "flex",
                flex: 1,
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",

                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: 200,
                    width: 250,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    marginBottom: 30,
                  }}
                >
                  <div style={{ marginBottom: 20 }}>IMAGE DISPLAY</div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      // marginLeft: 20,
                      borderStyle: "solid",
                      height: "90%",
                      borderRadius: 8,
                      borderColor: colors.greenDark,
                    }}
                  >
                    <img
                      alt="logo"
                      src={makeImage}
                      style={{ height: "100%" }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: 50,
                  }}
                >
                  <TextInputField
                    labelTitle={"MAKE NAME"}
                    mini={true}
                    value={makeName}
                    onChange={(e) => setMakeName(e.target.value)}
                  />
                  <TextInputField
                    labelTitle={"IMAGE LINK"}
                    mini={true}
                    value={makeImage}
                    onChange={(e) => setMakeImage(e.target.value)}
                  />
                  <div style={{ display: "flex", marginTop: 20 }}>
                    <BaseButtons
                      borderRadius={8}
                      backgroundColor={colors.orangeDark}
                      label={"CANCEL"}
                      width={120}
                      onClick={() => {
                        setAddMake(false);
                      }}
                    />
                    <div style={{ width: 20 }} />
                    <BaseButtons
                      borderRadius={8}
                      backgroundColor={colors.greenDark}
                      label={"SUBMIT"}
                      width={120}
                      onClick={() => AddNewMake()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* mangae screen */}
          <div
            style={{
              height: selectedMake ? "100%" : 0,
              width: "100%",
              overflow: "hidden",
              backgroundColor: colors.secondaryGrey,
              // position: "absolute",
              // top: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              transition: "all 0.3s",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                marginBottom: 20,
                fontSize: 20,
                marginTop: 20,
                width: "100%",
              }}
            >
              <div style={{ marginLeft: 20 }}>MANAGE MAKE</div>
            </div>
            <div style={{ display: "flex", flex: 1, width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 0.5,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: 200,
                    width: 250,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    marginBottom: 30,
                  }}
                >
                  <div style={{ marginBottom: 20 }}>IMAGE DISPLAY</div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      // marginLeft: 20,
                      borderStyle: "solid",
                      height: "90%",
                      borderRadius: 8,
                      borderColor: colors.greenDark,
                    }}
                  >
                    <img
                      alt="logo"
                      src={selectedMakeEditImage}
                      style={{ height: "100%" }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: 50,
                  }}
                >
                  {manageDeleteAreYouSure ? (
                    <div
                      style={{
                        fontWeight: "bold",
                        marginTop: 20,
                        marginBottom: 20,
                      }}
                    >
                      ARE YOU SURE YOU WANT TO DELETE THIS MAKE{" "}
                      {selectedMake ? selectedMake.name : null}?
                    </div>
                  ) : (
                    <TextInputField
                      labelTitle={"MAKE NAME"}
                      mini={true}
                      value={selectedMakeEdit}
                      onChange={(e) => setSelectedMakeEdit(e.target.value)}
                    />
                  )}
                  {manageDeleteAreYouSure ? null : (
                    <TextInputField
                      labelTitle={"IMAGE LINK"}
                      mini={true}
                      value={selectedMakeEditImage}
                      onChange={(e) => setSelectedMakeEditImage(e.target.value)}
                    />
                  )}
                  <div
                    style={{
                      display: "flex",
                      marginTop: 20,
                      justifyContent: "center",
                    }}
                  >
                    {manageDeleteAreYouSure ? null : (
                      <BaseButtons
                        borderRadius={8}
                        backgroundColor={colors.orangeDark}
                        label={"CANCEL"}
                        width={120}
                        onClick={() => {
                          setSelectedMake(null);
                          setSeriesArray(null);
                          setAddMake(false);
                          setAddSeires(false);
                          setSelectedSeries(null);
                          setSeriesSearch("");
                        }}
                      />
                    )}
                    <div style={{ width: 20 }} />
                    {manageDeleteAreYouSure ? (
                      <BaseButtons
                        borderRadius={8}
                        backgroundColor={colors.greenDark}
                        label={"YES"}
                        width={120}
                        onClick={() => deleteMake()}
                      />
                    ) : (
                      <BaseButtons
                        borderRadius={8}
                        backgroundColor={colors.greenDark}
                        label={"SAVE CHANGES"}
                        width={120}
                        onClick={() => EditMake()}
                        disabled={
                          selectedMake
                            ? selectedMake.name !== selectedMakeEdit ||
                              selectedMake.imageLink !== selectedMakeEditImage
                              ? false
                              : true
                            : true
                        }
                      />
                    )}
                    <div style={{ width: 20 }} />
                    {manageDeleteAreYouSure ? (
                      <BaseButtons
                        borderRadius={8}
                        backgroundColor={colors.orangeDark}
                        label={"NO"}
                        width={120}
                        onClick={() => setManageDeleteAreYouSure(false)}
                      />
                    ) : (
                      <BaseButtons
                        borderRadius={8}
                        backgroundColor={colors.orangeDark}
                        label={"DELETE"}
                        width={120}
                        onClick={() => setManageDeleteAreYouSure(true)}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flex: 0.5,
                  justifyContent: "flex-start",
                  alignItems: "center",
                  backgroundColor: colors.white,
                  borderTopLeftRadius: 20,
                  WebkitBoxShadow: "5px 5px 10px 10px #00000030",
                  position: "relative",
                  // height: "100%",
                }}
              >
                <div
                  style={{
                    marginBottom: 10,
                    marginTop: 5,
                    fontSize: 16,
                    fontWeight: "bold",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div style={{ marginLeft: 20 }}>LINKED SERIES</div>
                  <div style={{ flex: 1 }}>
                    <TextInputField
                      value={seriesSearch}
                      onChange={(e) => setSeriesSearch(e.target.value)}
                      mini={true}
                      marginTop={-5}
                      placeholder={"TYpe here to search series type"}
                    />
                  </div>
                  <div style={{ marginRight: 10 }}>
                    <BaseButtons
                      label={"ADD SERIES"}
                      height={35}
                      backgroundColor={colors.greenLight}
                      borderRadius={8}
                      width={110}
                      onClick={() => setAddSeires(true)}
                    />
                  </div>
                </div>
                {/* list display */}
                <div
                  style={{
                    flex: 1,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "scroll",
                    overflowX: "hidden",
                    justifyContent: "flex-start",
                    maxHeight: height - 220,
                    minHeight: height - 220,
                  }}
                >
                  {seriesArray ? (
                    seriesArray.map((series, index) => {
                      return series.name.match(
                        seriesSearch.toLocaleUpperCase()
                      ) ? (
                        <div
                          onClick={() => setSelectedSeries(series)}
                          onMouseOver={() => setSeriesCardHover(index)}
                          onMouseOut={() => setSeriesCardHover(null)}
                          key={index}
                          style={{
                            cursor: "pointer",
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: 10,
                          }}
                        >
                          <div
                            style={{
                              height: 135,
                              borderStyle: "solid",
                              width: "92%",
                              borderRadius: 8,
                              display: "flex",
                              borderColor: colors.greenLight,
                              backgroundColor:
                                seriesCardHover === index
                                  ? colors.greenLight50
                                  : colors.white,
                              WebkitBoxShadow:
                                seriesCardHover === index
                                  ? "0px 0px 5px 5px #00000030"
                                  : "0px 0px 0px 0px #00000030",
                              transition: "all 0.3s",
                            }}
                          >
                            <div
                              style={{
                                height: "90%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                flex: 0.7,
                              }}
                            >
                              <TextInputField
                                value={series.name}
                                mini={true}
                                readOnly={true}
                                size={"80%"}
                                width={"100%"}
                              />
                              <TextInputField
                                value={series.imageLink}
                                mini={true}
                                readOnly={true}
                                size={"80%"}
                                width={"100%"}
                              />
                            </div>
                            <div
                              style={{
                                flex: 0.3,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                alt="logo"
                                src={series.imageLink}
                                style={{ height: "100%" }}
                              />
                            </div>
                          </div>
                        </div>
                      ) : null;
                    })
                  ) : (
                    <LoadingPopUp />
                  )}
                  <div style={{ padding: 20 }} />
                </div>
                {/* add new series display */}
                <div
                  style={{
                    height: addSeries ? "100%" : 0,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    overflowY: addSeries ? "scroll" : "hidden",
                    overflowX: "hidden",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    backgroundColor: colors.white,
                    borderTopLeftRadius: 20,
                    opacity: addSeries ? 1 : 0,
                    transition: "all 0.3s",

                    //top: 0,
                  }}
                >
                  <div
                    style={{
                      height: 200,
                      width: 250,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      marginBottom: 30,
                    }}
                  >
                    <div style={{ marginBottom: 20, fontWeight: "bold" }}>
                      ADD NEW SERIES
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        // marginLeft: 20,
                        borderStyle: "solid",
                        height: "90%",
                        borderRadius: 8,
                        borderColor: colors.greenDark,
                      }}
                    >
                      <img
                        alt="logo"
                        src={seriesImage}
                        style={{ height: "100%" }}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: 50,
                    }}
                  >
                    <TextInputField
                      labelTitle={"SERIES NAME"}
                      mini={true}
                      value={seriesName}
                      onChange={(e) => setSeriesName(e.target.value)}
                    />
                    <TextInputField
                      labelTitle={"IMAGE LINK"}
                      mini={true}
                      value={seriesImage}
                      onChange={(e) => setSeriesImage(e.target.value)}
                    />
                    <div style={{ display: "flex", marginTop: 20 }}>
                      <BaseButtons
                        borderRadius={8}
                        backgroundColor={colors.orangeDark}
                        label={"CANCEL"}
                        width={120}
                        onClick={() => {
                          setAddSeires(false);
                        }}
                      />
                      <div style={{ width: 20 }} />
                      <BaseButtons
                        borderRadius={8}
                        backgroundColor={colors.greenDark}
                        label={"SAVE CHANGES"}
                        width={120}
                        onClick={() => AddNewSeries()}
                      />
                    </div>
                  </div>
                </div>
                {/* manage series display */}
                <div
                  style={{
                    height: selectedSeries ? "100%" : 0,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    overflowY: selectedSeries ? "scroll" : "hidden",
                    overflowX: "hidden",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "absolute",
                    backgroundColor: colors.white,
                    borderTopLeftRadius: 20,
                    opacity: selectedSeries ? 1 : 0,
                    transition: "all 0.3s",
                    top: 0,
                  }}
                >
                  <div
                    style={{
                      height: 200,
                      width: 250,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      marginBottom: 30,
                    }}
                  >
                    <div style={{ marginBottom: 20, fontWeight: "bold" }}>
                      MANAGE SERIES
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        // marginLeft: 20,
                        borderStyle: "solid",
                        height: "90%",
                        borderRadius: 8,
                        borderColor: colors.greenDark,
                      }}
                    >
                      <img
                        alt="logo"
                        src={selectedSeriesEditImage}
                        style={{ height: "100%" }}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginBottom: 50,
                    }}
                  >
                    {seriesDeleteAreYouSure ? (
                      <div
                        style={{
                          fontWeight: "bold",
                          marginTop: 20,
                          marginBottom: 20,
                        }}
                      >
                        ARE YOU SURE YOU WANT TO DELETE THIS SERIES{" "}
                        {selectedSeries ? selectedSeries.name : null}?
                      </div>
                    ) : (
                      <TextInputField
                        labelTitle={"SERIES NAME"}
                        mini={true}
                        value={selectedSeriesEdit}
                        onChange={(e) => setSelectedSeriesEdit(e.target.value)}
                      />
                    )}
                    {seriesDeleteAreYouSure ? null : (
                      <TextInputField
                        labelTitle={"IMAGE LINK"}
                        mini={true}
                        value={selectedSeriesEditImage}
                        onChange={(e) =>
                          setSelectedSeriesEditImage(e.target.value)
                        }
                      />
                    )}
                    <div
                      style={{
                        display: "flex",
                        marginTop: 20,
                        justifyContent: "center",
                      }}
                    >
                      {seriesDeleteAreYouSure ? null : (
                        <BaseButtons
                          borderRadius={8}
                          backgroundColor={colors.orangeDark}
                          label={"CANCEL"}
                          width={120}
                          onClick={() => {
                            setAddSeires(false);
                            setSelectedSeries(null);
                            setSelectedSeriesEditImage("");
                            setSelectedSeriesEdit("");
                          }}
                        />
                      )}
                      <div style={{ width: 20 }} />
                      {seriesDeleteAreYouSure ? (
                        <BaseButtons
                          borderRadius={8}
                          backgroundColor={colors.greenDark}
                          label={"YES"}
                          width={120}
                          onClick={() => deleteSeries()}
                        />
                      ) : (
                        <BaseButtons
                          borderRadius={8}
                          backgroundColor={colors.greenDark}
                          label={"SAVE CHANGES"}
                          width={120}
                          onClick={() => EditSeries()}
                        />
                      )}
                      <div style={{ width: 20 }} />
                      {seriesDeleteAreYouSure ? (
                        <BaseButtons
                          borderRadius={8}
                          backgroundColor={colors.orangeDark}
                          label={"NO"}
                          width={120}
                          onClick={() => setSeriesDeleteAreYouSure(false)}
                        />
                      ) : (
                        <BaseButtons
                          borderRadius={8}
                          backgroundColor={colors.orangeDark}
                          label={"DELETE"}
                          width={120}
                          onClick={() => setSeriesDeleteAreYouSure(true)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {tableDisplay === "driverVehicles" ? (
        <div
          style={{
            flex: 1,
            height: "99%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* top actions and title */}
          <div
            style={{
              height: 55,
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div style={{ marginLeft: 20, fontSize: 18, fontWeight: "bold" }}>
              USER REGISTERED VEHICLES
            </div>

            <div style={{ flex: 0.5 }}></div>
            <SearchBar
              originalSearchArray={originalUsersArray}
              arrayToSearchInput={userRegisteredVehicles}
              setResultsArray={setUserRegisteredVehicles}
            />
            <div style={{ flex: 0.5 }}></div>
          </div>
          {/* header */}
          <div
            style={{
              width: "100%",
              backgroundColor: colors.greenDark,
              height: 40,
              display: "flex",
            }}
          >
            <div
              style={{
                flex: 0.15,
                color: colors.white,
                fontWeight: "bold",
                fontSize: 12,
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ width: "100%" }}>
                <div style={{ marginLeft: 10 }}>REGISTER NR</div>
              </div>
            </div>
            <div
              style={{
                flex: 0.15,
                color: colors.white,
                fontWeight: "bold",
                fontSize: 12,
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ width: "100%" }}>
                <div style={{ marginLeft: 10 }}> LICENCE NR</div>
              </div>
            </div>
            <div
              style={{
                flex: 0.2,
                color: colors.white,
                fontWeight: "bold",
                fontSize: 12,
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ width: "100%" }}> VIN NR</div>
            </div>
            <div
              style={{
                flex: 0.2,
                color: colors.white,
                fontWeight: "bold",
                fontSize: 12,
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ width: "100%" }}> ENGINE NR</div>
            </div>
            <div
              style={{
                flex: 0.1,
                color: colors.white,
                fontWeight: "bold",
                fontSize: 12,
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ width: "100%" }}> MAKE</div>
            </div>
            <div
              style={{
                flex: 0.1,
                color: colors.white,
                fontWeight: "bold",
                fontSize: 12,
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ width: "100%" }}>SERIES</div>
            </div>
            <div
              style={{
                flex: 0.1,
                color: colors.white,
                fontWeight: "bold",
                fontSize: 12,
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "left",
              }}
            >
              ACTIONS
            </div>
          </div>
          <div
            style={{
              flex: 1,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              overflowX: "hidden",
              overflowY: "scroll",
            }}
          >
            {userRegisteredVehicles
              ? userRegisteredVehicles.map((vehicle, index) => {
                  return (
                    <div
                      key={index}
                      style={{
                        width: "100%",
                      }}
                    >
                      <UserRegisterVehicleCard
                        vehicle={vehicle}
                        onManageClick={() => {
                          setActiveView("manage");
                          setSelectedVehicle(vehicle);
                        }}
                      />
                    </div>
                  );
                })
              : null}
          </div>
        </div>
      ) : null}
      {/* add Vehicle view */}
      <AddVehiclePopUp
        activeView={activeView}
        setActiveView={setActiveView}
        SubmitHandler={SubmitHandler}
        regsitrationNr={regsitrationNr}
        setRegistrationNr={setRegistrationNr}
        vinNr={vinNr}
        setVinNr={setVinNr}
        licenceNr={licenceNr}
        setLicenceNr={setLicenceNr}
        engineNr={engineNr}
        setEngineNr={setEngineNr}
        make={make}
        setMake={setMake}
        series={series}
        setSeries={setSeries}
        setToastPop={setToastPop}
        setMessage={setMessage}
        GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
        makeArray={makeArray}
        seriesArray={seriesArray}
        auth={auth}
        loading={loading}
        setLoading={setLoading}
        searchRegister={searchRegister}
        setSearchRegister={setSearchRegister}
        setSeriesArray={setSeriesArray}
        refresh={refresh}
        setRefresh={setRefresh}
        setPopUpTitle={setPopUpTitle}
        setLinkedUserIdNumber={setLinkedUserIdNumber}
        linkedUserIdNumber={linkedUserIdNumber}
      />
      {/* manage product view */}
      <ManageVehiclePopUp
        selectedVehicle={selectedVehicle}
        activeView={activeView}
        setActiveView={setActiveView}
        SubmitHandler={null}
        regsitrationNr={regsitrationNr}
        setRegistrationNr={setRegistrationNr}
        vinNr={vinNr}
        setVinNr={setVinNr}
        licenceNr={licenceNr}
        setLicenceNr={setLicenceNr}
        engineNr={engineNr}
        setEngineNr={setEngineNr}
        make={make}
        setMake={setMake}
        series={series}
        setSeries={setSeries}
        tableDisplay={tableDisplay}
        auth={auth}
        setSelectedVehicle={setSelectedVehicle}
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setToastPop={setToastPop}
        setLoading={setLoading}
        setRefresh={setRefresh}
        refresh={refresh}
      />
      {/* <LoadingPopUp display={loading} /> */}
    </div>
  );
};

export default VehicleDisplay;
